import React from 'react';
import { Button, Dropdown, Tag, Tooltip, Typography } from 'antd';
import {
    PlayCircleOutlined,
    MoreOutlined,
    TeamOutlined,
    DeleteOutlined,
    EditOutlined,
    FolderOutlined,
    TagOutlined,
} from '@ant-design/icons';
import { formatDateTime, formatFileSize } from '../../utils/format';
import { CATEGORY_TAG_COLOR, TAG_CHIP_COLOR } from './videoTaxonomyStyles';
import VideoCardPreview from './VideoCardPreview';

const VIDEO_STATUS = {
    '0': { text: '正常', color: 'success' },
    '1': { text: '磁盘缺失', color: 'warning' },
};

class VideoCard extends React.Component {
    render() {
        const {
            video,
            onPlay,
            onAssign,
            onDelete,
            onEditMeta,
            onPreviewVerified,
            showAssign,
            showDelete,
            showEditMeta,
        } = this.props;

        const statusCfg = VIDEO_STATUS[video.status] || { text: video.status, color: 'default' };
        const ext = (video.fileExt || '').toUpperCase() || 'VIDEO';
        const tagList = video.tags || [];

        const menuItems = [
            showEditMeta && {
                key: 'meta',
                icon: <EditOutlined />,
                label: '设置分类与标签',
                onClick: () => onEditMeta(video),
            },
            showAssign && {
                key: 'assign',
                icon: <TeamOutlined />,
                label: '分配观看',
                onClick: () => onAssign(video),
            },
            showDelete && {
                key: 'delete',
                icon: <DeleteOutlined />,
                label: '删除记录',
                danger: true,
                onClick: () => onDelete(video),
            },
        ].filter(Boolean);

        return (
            <article className="video-card">
                <button
                    type="button"
                    className="video-card__cover"
                    onClick={() => onPlay(video)}
                    aria-label={`播放 ${video.fileName}`}
                >
                    <VideoCardPreview
                        videoId={video.id}
                        fileExt={video.fileExt}
                        updateTime={video.updateTime}
                        staleMissing={video.status === '1'}
                        onPreviewVerified={onPreviewVerified}
                    />
                    <span className="video-card__ext">{ext}</span>
                    <span className="video-card__play">
                        <PlayCircleOutlined />
                    </span>
                    <Tag className="video-card__status" color={statusCfg.color}>
                        {statusCfg.text}
                    </Tag>
                </button>

                <div className="video-card__body">
                    <Tooltip title={video.fileName}>
                        <Typography.Paragraph className="video-card__title" ellipsis={{ rows: 2 }}>
                            {video.fileName}
                        </Typography.Paragraph>
                    </Tooltip>
                    <div className="video-card__meta">
                        <span>{formatFileSize(video.fileSize)}</span>
                        <span className="video-card__meta-sep">·</span>
                        <span>{formatDateTime(video.createTime)}</span>
                    </div>
                    <div className="video-card__taxonomy">
                        <div className="video-card__taxonomy-row">
                            <span className="video-card__taxonomy-label">
                                <FolderOutlined aria-hidden />
                                分类
                            </span>
                            {video.categoryName ? (
                                <Tag color={CATEGORY_TAG_COLOR} className="video-card__category">
                                    {video.categoryName}
                                </Tag>
                            ) : (
                                <span className="video-card__taxonomy-empty">未分类</span>
                            )}
                        </div>
                        <div className="video-card__taxonomy-row">
                            <span className="video-card__taxonomy-label">
                                <TagOutlined aria-hidden />
                                标签
                            </span>
                            {tagList.length > 0 ? (
                                <span className="video-card__tag-list">
                                    {tagList.map((t) => (
                                        <Tag
                                            key={t.id}
                                            color={TAG_CHIP_COLOR}
                                            bordered
                                            className="video-card__tag-chip"
                                        >
                                            {t.tagName}
                                        </Tag>
                                    ))}
                                </span>
                            ) : (
                                <span className="video-card__taxonomy-empty">无标签</span>
                            )}
                        </div>
                    </div>
                    <div className="video-card__actions">
                        <Button
                            type="primary"
                            icon={<PlayCircleOutlined />}
                            onClick={() => onPlay(video)}
                            block
                        >
                            播放
                        </Button>
                        {menuItems.length > 0 && (
                            <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                                <Button icon={<MoreOutlined />} aria-label="更多操作" />
                            </Dropdown>
                        )}
                    </div>
                </div>
            </article>
        );
    }
}

export default VideoCard;
